import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-05e7c092"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "title" }
const _hoisted_2 = { class: "subtitle" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = ["href"]

import { onMounted, ref } from 'vue';
  import InformationService from '@/services/InformationService';
  
  
export default /*#__PURE__*/_defineComponent({
  __name: 'ProdevBanner',
  setup(__props) {

  const service = new InformationService();
  const currentBanner = ref({});
  const informationMulti = ref([]);
  const information = ref({})
  let currentBannerIndex = 0;
  
  const changeBanner = () => {
    currentBannerIndex = (currentBannerIndex + 1) % informationMulti.value.length;
    currentBanner.value = informationMulti.value[currentBannerIndex];
  };
  
  onMounted(async () => {
    informationMulti.value = await service.GetInformationMulti();
    currentBanner.value = informationMulti.value[currentBannerIndex];
    setInterval(changeBanner, 12000); // Cambiar cada dos minutos (120 segundos)
    information.value = await service.GetInformation()
    console.log(window.innerWidth);})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    style: _normalizeStyle({ 'background-image': `url(${currentBanner.value.bg_uri})`})
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h1", null, _toDisplayString(currentBanner.value.title), 1)
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(currentBanner.value.description), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      (currentBanner.value.action)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "button acc",
            href: currentBanner.value.action
          }, "Acceder", 8, _hoisted_4))
        : _createCommentVNode("", true)
    ])
  ], 4))
}
}

})